import startHeatSiren from "./normalized_start_heat_siren.m4a";
import { useAudio } from "./useAudio";

interface StartSirenAudioProps {
    isMuted: boolean;
}

export const useStartSirenAudio = ({ isMuted }: StartSirenAudioProps) => {
    const { play } = useAudio(startHeatSiren);
    const playStartSirenSound = () => {
        if (isMuted) return;
        play();
    };
    return { playStartSirenSound };
};
